import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const storeHomeSchemeQuery = gql`
  query StoreHomeScheme($locale: String, $organisationId: ID, $schemeType: ID!) {
    storeHomeSchemeData(locale: $locale, organisationId: $organisationId, schemeType: $schemeType) {
      employeeOrganisation {
        scheme {
          id
          windowStartDate
          windowEndDate
          brochureGroups {
            id
            term
          }
          bikeDepartmentId
        }
      }
    }
  }
`
export const getStoreHomeSchemeQueryKey = getQueryNames(storeHomeSchemeQuery)[0]
export {storeHomeSchemeQuery}
